var _g, _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackHeartObj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_555_12006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.075 0C4.06296 0 0 4.10311 0 9.16616C0 14.4725 2.99227 19.4789 7.94062 24.062C9.62956 25.6252 11.448 26.9968 13.2515 28.2284C13.8836 28.6584 14.4748 29.0484 15.0048 29.3734C15.3278 29.5717 15.5409 29.715 15.675 29.79C16.1733 30.07 16.8267 30.07 17.325 29.79C17.4591 29.715 17.6722 29.5717 17.9952 29.3734C18.5252 29.0484 19.1164 28.6584 19.7485 28.2284C21.552 26.9968 23.3704 25.6252 25.0594 24.062C30.0077 19.4789 33 14.4725 33 9.16616C33 4.10311 28.937 0 23.925 0C21.0784 0 18.2992 1.5666 16.5515 3.85314C14.8474 1.5266 12.0778 0 9.075 0Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 12.5,
    r: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19L18.7321 16.75H15.2679L17 19Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_555_12006",
    x: 0,
    y: 0,
    width: 36,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_555_12006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_555_12006",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackHeartObj);
export default __webpack_public_path__ + "static/media/BlackHeartObj.abe7408b678cb0e4391ba9f90ea5beb8.svg";
export { ForwardRef as ReactComponent };